import Image from 'next/image';
import clsx from 'clsx';
import { prepareImagePath } from '../../services/lib/util';
import { PlayIcon } from '../icons';

export const YoutubeCover = ({
  coverImage,
  alt = 'Canal+',
  title = null,
  handleClick,
  isActive = false,
  className,
}) => {
  if (isActive) return null;

  return (
    <button
      type="button"
      onClick={handleClick}
      aria-label="Odtwórz wideo"
      className={clsx(
        'youtubeCover absolute inset-0 z-[2] block h-full w-full cursor-pointer overflow-hidden rounded-[16px] border-none bg-transparent p-0 px-0 focus:outline-none',
        className,
      )}
    >
      {coverImage && (
        <Image
          src={prepareImagePath(coverImage)}
          alt={alt}
          title={title}
          fill
          sizes="(max-width: 768px) 100vw, 50vw"
          className="object-cover px-0"
        />
      )}

      <PlayIcon className="playIcon px-0" />
    </button>
  );
};
